/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState } from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import CommentIconVisible from '../../../../../assets/images/commen-visible-icon.svg';
import CommentIcon from '../../../../../assets/images/comment-dots.svg';
import SaveCancelPopup from '../../../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';
import SVGComponent from '../../../../../SharedModules/SVGComponents/SVGComponents';
import {
  deleteRowFromData,
  setPriceLoadDetailsChanged,
  triggerCommentsExistingCheck,
  currentCorrLinkID
} from '../../store/action';
import { multiPriceSelectionRadioData } from '../../utils/constant';
import CommentAndCorrespondenceComponent from '../../../../../SharedModules/MicroFrontend/CommentAndCorrespondenceComponent';
import { checkActionAccessByRole } from '../../../../../SharedModules/utilities/utilities';

const RequestDrugPriceLoadDetailsActionComponent = (props) => {
  const { data, disabled } = props;
  const { kcRoles } = useSelector((state) => state.sharedState.SharedReducer);
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [corrLinkId, setCorrLinkId] = useState(null);
  const [corrId, setCorrId] = useState(null);
  const [showComments, setShowComments] = useState(false);
  const [commentDisable, setCommentDisable] = useState(false)
  const [isEnablebyRole, setIsEnablebyRole] = useState(
    checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
  );
const priceLoadDetailsTableData = useSelector(
    (state) => state.sharedState.requestDrugPriceLoad.priceLoadDetailsTableData
  );



  useEffect(() => {
    if (kcRoles?.userPrivileges.length > 0) {
      setIsEnablebyRole(
        checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
      );
    }
  }, []);
  React.useEffect(()=>{
    if((Array.isArray(priceLoadDetailsTableData?.priceTableData)&&priceLoadDetailsTableData?.priceTableData?.length===1&&
    priceLoadDetailsTableData?.priceTableData?.[0]?.corrLinkId==="new") || data.isAddedFromUI){
      setCommentDisable(true)
    }else{
      setCommentDisable(false)
    }
  },[priceLoadDetailsTableData])

  const handleShowComments = (value) => {
    dispatch(triggerCommentsExistingCheck(Math.random()));
    setShowComments(value);
  };

  return (
    <>
      <div
        className='tdCell icon-btn-group text-black d-flex mh-100 h-100 align-items-center'
        style={{ top: 0 }}
      >
        <OverlayTrigger
          placement='bottom'
          overlay={<Tooltip id='delete-tooltip'>Comment</Tooltip>}
        >
          <Button className='p-0' variant='text' disabled={ commentDisable}>
            {data.ccCommentsExist !== '' && data.ccCommentsExist !== null ? (
              <img
                alt='comment'
                role='button'
                src={
                  data && data.ccCommentsExist
                    ? CommentIconVisible
                    : CommentIcon
                }
                onClick={() => {
                  dispatch(currentCorrLinkID(data?.corrLinkId))
                  setCorrLinkId(data?.corrLinkId);
                  setCorrId(data?.productCode); //check setCorrId
                  setShowComments(true);
                }}
                tabIndex={'0'}
                onKeyDown={(e) => {
                  // Handle Enter and Space key events
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault(); // Prevents the default space scrolling behavior
                    setShowComments(true);
                  }
                }}
              />
            ) : (
              <SVGComponent iconName='Icon-comment' />
            )}
          </Button>
        </OverlayTrigger>

        <OverlayTrigger
          placement='bottom'
          overlay={<Tooltip id='delete-tooltip'>Delete</Tooltip>}
        >
          <Button
            data-testid='deleteBtn'
            className='th-ic trash-blue'
            variant='text'
            disabled={disabled || !isEnablebyRole || commentDisable}
            onClick={() => setOpen(true)}
            aria-label='Delete'
          >
            <SVGComponent iconName='Icon-delete' />
          </Button>
        </OverlayTrigger>
      </div>
      <SaveCancelPopup
        data-testid='handleDelete'
        open={open}
        title={'Delete'}
        moduleName={'the selected record'}
        onConfim={() => {
          dispatch(
            deleteRowFromData(
              data,
              data['calcUra'] !== undefined
                ? multiPriceSelectionRadioData[1].value
                : multiPriceSelectionRadioData[0].value
            )
          );
          dispatch(setPriceLoadDetailsChanged(true));
          setOpen(false);
        }}
        onCancel={() => {
          setOpen(false);
        }}
        onClose={(reason) => {}}
      />
      {showComments ? (
        <CommentAndCorrespondenceComponent
          setShowComments={handleShowComments}
          linkTableName={
            multiPriceSelectionRadioData.every((val) => {
              return val.value;
            }) === 'Price'
              ? 'PRICE'
              : 'CALCULATED_URA'
          }
          corrLinkId={corrLinkId}
          rowGridPrimaryKey={corrId}
        />
      ) : null}
    </>
  );
};

export default RequestDrugPriceLoadDetailsActionComponent;
